// AuditSummary.jsx
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ReusableTable from "../../ReusableTable/ReusableTable";
import { env } from "../../../constants/env";
import { useAuth } from "../../../context/AuthContext";
import classes from "./AuditSummary.module.css"; // create CSS module for overlay

const AuditSummary = () => {
  const { labId } = useParams();
  const navigate = useNavigate();
  const [summaries, setSummaries] = useState([]);
  const [loading, setLoading] = useState(false);
  const { user } = useAuth();
  const userRole = user?.role;

  const [selectedSummary, setSelectedSummary] = useState(null);

  const auditSummaryColumns = [
    { label: "Date Created", field: "dateCreated" },
    { label: "Total Score", field: "totalScore" },
    { label: "Stars Rating", field: "stars" },
  ];

  useEffect(() => {
    const fetchSummaries = async () => {
      try {
        setLoading(true);
        const res = await fetch(
          `${env.kataApiUrl}/api/certification/audit-summary?labId=${labId}`
        );
        const data = await res.json();
        setSummaries(data);
      } catch (err) {
        console.error("Failed to fetch audit summaries", err);
      } finally {
        setLoading(false);
      }
    };

    if (labId) fetchSummaries();
  }, [labId]);

  return (
    <div>
      <ReusableTable
        title="Audit Summary"
        showTopAdd={userRole === "ASSESSOR" ? summaries.length > 0 : false}
        columns={auditSummaryColumns}
        data={summaries}
        loading={loading}
        onAdd={
          userRole === "ASSESSOR" ? () => navigate("add-audit-summary") : false
        }
        useOverlay
        onShowDetails={(row) => setSelectedSummary(row)} // pass handler
      />

      {/* Overlay Drawer */}
      {selectedSummary && (
        <div className={classes.overlay}>
          <div className={classes.drawer}>
            <div className="d-flex align-items-center justify-content-between">
              <div>
                <h3>{selectedSummary.labName}</h3>
                <div className={classes.licenseContainer}>{selectedSummary.hpczLicense}</div>
              </div>
              <button
                className={classes.closeBtn}
                onClick={() => setSelectedSummary(null)}
              >
                ✕
              </button>
            </div>

            <div
              className={`${classes.mainStats} d-flex align-items-center justify-content-between my-4`}
            >
              <div>
                <h5>Created</h5>
                <p>{selectedSummary.dateCreated}</p>
              </div>
              <div>
                <h5>Total score</h5>
                <p>{selectedSummary.totalScore}</p>
              </div>
              <div>
                <h5>Stars rating</h5>
                <span>{selectedSummary.starsValue} {" "}{selectedSummary.stars}</span>
              </div>
            </div>

            <h5>Individual ratings</h5>
            <ul>
              {selectedSummary.sections?.map((s, i) => (
                <li key={i}>
                  <div
                    className={`${classes.individualStats} d-flex align-items-center justify-content-between`}
                  >
                    <div>
                      <p>{s.section}</p>
                    </div>{" "}
                    <div>
                      <p>{s.score}</p>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

export default AuditSummary;
